import { render } from "./GameRulesWheel.vue?vue&type=template&id=5fb33262&scoped=true"
import script from "./GameRulesWheel.vue?vue&type=script&lang=js"
export * from "./GameRulesWheel.vue?vue&type=script&lang=js"

import "./GameRulesWheel.vue?vue&type=style&index=0&id=5fb33262&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb33262"]])

export default __exports__